import AuthService from '../../services/login'
import CookieManager from '../../src/lib/CookiesManager'

class TokenManager {
  private static instance: TokenManager
  private refreshPromise: Promise<void> | null = null
  private readonly REFRESH_THRESHOLD = 3600 * 60 * 1000

  private constructor() {}

  public static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager()
    }
    return TokenManager.instance
  }

  public async checkAndRefreshToken(): Promise<boolean> {
    if (this.refreshPromise) {
      await this.refreshPromise
      return true
    }

    const token = CookieManager.getToken()

    const expiration = CookieManager.getAuth()?.expiration

    if (!token || !expiration) {
      return false
    }

    const expirationTime = new Date(expiration).getTime()
    const currentTime = new Date().getTime()
    const timeLeft = expirationTime - currentTime

    if (timeLeft < this.REFRESH_THRESHOLD) {
      this.refreshPromise = this.refreshToken()
      try {
        await this.refreshPromise
        return true
      } catch (error) {
        console.error('Erreur lors du rafraîchissement du token:', error)
        return false
      } finally {
        this.refreshPromise = null
      }
    }

    return true
  }

  private async refreshToken(): Promise<void> {
    try {
      await AuthService.refreshToken()
    } catch (error) {
      console.error('Échec du rafraîchissement du token:', error)
      throw error
    }
  }
}

export default TokenManager.getInstance()
